import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export function TeachersLayout() {
  return (
    <Box sx={{ width: '100%' }}>
      <Outlet />
    </Box>
  );
}
